/**
 * Scenario model and DTOs for define-scenario / post-call classification
 */
export const SCENARIO_TYPE_VALUES = [
    'EMERGENCY',
    'MAINTENANCE',
    'LEASING',
];
/** Predefined variables per scenario type. */
export const SCENARIO_VARIABLES = {
    EMERGENCY: [
        { name: 'property', description: 'Property name' },
        { name: 'unit', description: 'Unit number' },
        { name: 'contactName', description: 'Contact name' },
        { name: 'issueDescription', description: 'Issue description' },
    ],
    LEASING: [
        { name: 'firstName', description: 'Lead first name' },
        { name: 'lastName', description: 'Lead last name' },
        {
            name: 'shortAddress',
            description: 'Street + city of the matched listing (e.g. "408 Troy Rd, Charlotte"). Preferred for spoken/read-aloud addresses.',
        },
        {
            name: 'property',
            description: 'Legacy alias — now resolves to the same value as `shortAddress` when a listing matches, otherwise the raw address from the webhook. Prefer `shortAddress` in new templates.',
        },
        { name: 'unit', description: 'Unit number' },
        { name: 'phone', description: 'Lead phone number' },
        { name: 'email', description: 'Lead email address' },
        { name: 'comments', description: 'Lead comments or notes' },
        { name: 'listingURL', description: 'URL to listing or showing calendar' },
    ],
    MAINTENANCE: [],
};
/**
 * Map an agent's metadata.scenario (e.g. LEASING_OUTBOUND, EMERGENCY_OUTBOUND)
 * to the full list of variable names for that scenario type.
 * Returns undefined if scenario is not recognized.
 */
const SCENARIO_TO_TYPE = {
    LEASING_OUTBOUND: 'LEASING',
    LEASE_RENEWAL_OUTBOUND: 'LEASING',
    EMERGENCY_OUTBOUND: 'EMERGENCY',
    DELINQUENCY_OUTBOUND: 'LEASING',
};
export function getScenarioVariableNames(scenario, triggerType) {
    let type = scenario ? SCENARIO_TO_TYPE[scenario] : undefined;
    // Fallback for agents without metadata.scenario (e.g. created from scratch or stripped by old save)
    if (!type && triggerType === 'WEBHOOK')
        type = 'LEASING';
    if (!type && triggerType === 'SCENARIO')
        type = 'EMERGENCY';
    if (!type)
        return undefined;
    return SCENARIO_VARIABLES[type].map(v => v.name);
}
//# sourceMappingURL=scenario.js.map